<script>
import baseList from "@/views/components/base/baseList.vue";

export default {
  extends: baseList,
  components: {
    Image,
  },
  data() {
    return {
      table: {
        mname: "customer",
        key: "id",
        url: {
        },
        output: false,
        order:'id',
        qrCode: "qrCode",
      },
      actions: [
        {
          label: "新增客户",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "/admin/customer/add",
          type: "info",
        },
      ],
      filters: [
        { label: "客户名称",KeyEnter : this.search, name: "customerName", value: "", type: "input" },
        { label: "联系电话",KeyEnter : this.search, name: "mobile", value: "", type: "input" },
        { label: "联系地址",KeyEnter : this.search, name: "address", value: "", type: "input" },
        { label: "联系人",KeyEnter : this.search, name: "name", value: "", type: "input" },
        { label: "公司域名",KeyEnter : this.search, name: "host", value: "", type: "input" },
      ],
      tableCols: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: "客户名称",
          key: "customerName",
          minWidth: 160,
          align: "left",
        },
        {
          title: "联系电话",
          key: "mobile",
          minWidth: 160,
          align: "left",
        },
        {
          title: "联系地址",
          key: "address",
          minWidth: 160,
          align: "left",
        },
        {
          title: "LOGO",
          key: "logo",
          minWidth: 160,
          align: "center",
        },
        {
          title: "公司域名",
          key: "host",
          minWidth: 260,
          align: "left",
        },
        {
          title: "联系人",
          key: "name",
          minWidth: 160,
          align: "left",
        },
        {
          title: "入驻日期",
          key: "createTime",
          minWidth: 170,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 260,
          key: "handle",
          fixed: "right",
          handle: [
            "edit",
          ],
          auth: {
            edit: "/admin/customer/edit",
          },
        },
      ],
    };
  },
  created() {
  },
  methods: {
    //选中
    handleSelect(selected) {
      let ids_arr = [];
      let arry = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        ids_arr.push(element[this.table.key]);
        arry.push(element[this.table.qrCode]);
      }
      this.selected = ids_arr.join(",");
      this.arrys = arry;
    },
    toAdd() {
      $utils.url.push({ name: "customer_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "customer_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
  },
};
</script>
<style scoped></style>
